import { MenuItem, Stack } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import Paper from "@mui/material/Paper";

export const StyledPaper = styled(Paper)`
  padding: 20px;
  margin-bottom: 5px;
  margin-top: 5px;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 600px) {
      flex-direction: column;
      align-items: start;
    }
  }
`;

export const Styleddetails = styled.details`
  padding: 4px;
  padding-right: 10px;
  padding-left: 10px;
  & > summary {
    background: white;
    border-radius: 4px;
    box-shadow: 0 0 5px rgb(194, 194, 194);
    padding: 10px;
  }
  & > summary > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 600px) {
      flex-direction: column;
      align-items: start;
    }
  }
`;

export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: gray;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: 10px;
  text-align: left;
`;
export const StyledMenuItem = styled(MenuItem)`
  text-align: right !important;
  direction: rtl;
`;
